import React, { Fragment, memo } from 'react'
import { SourcingBuyerStyled } from './styled'
import {
  Button,
  Modal,
  Image,
  InputSearch,
  Paginate,
  Section,
  SelectBox,
  Table,
  Input,
  Text,
  Breadcrumbs,
  Checkbox,
  Spinner,
} from '../../components'
import { ICONS } from '../../themes'
// import { isEmpty } from 'lodash'
import {
  // filterSearchSourcingInput1,
  // filterSearchSourcingOptions2,
  // filterSearchSourcingOptions3,
  // filterSearchSourcingOptions4,
  // filterSearchSourcingOptions5,
  startApiRequestUnseal,
  startApiRequestUnsealTec,
  searchEventListSearch,
  searchEventListAllStatus,
  searchEventListAllEventType,
  searchEventListSealStatus,
  searchEventListAllAward,
  searchEventListAllUser,
  filterPageAllEvent,
} from '../../store/actions'
import {
  auctionController,
  rfqController,
  eventNewController,
} from '../../apiService'
import {
  ROUTE_PATH,
  // STRING,
  toastActive,
  toastFail,
  // localStorageService,
} from '../../helpers'
import {
  dateMonDayYearTime,
  formatNumberWithComma,
} from '../../helpers/functions/format'
import FileDownload from 'js-file-download'
import { store } from 'store'
import { connect } from 'react-redux'
import NumberFormat from 'react-number-format'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { pageSourcingBuyerController, rolesObj } from '../../middleware'
import { find, map, filter, has } from 'lodash'
const optionsSealStatus = [
  { value: 0, label: 'All Seal Status' },
  { value: 2, label: 'Awaiting Unseal' },
  { value: 3, label: 'Unsealed' },
  { value: 1, label: 'Sealed' },
  { value: 10, label: '-' },
]

export class SourcingBuyerContainers extends React.Component {
  _isMounted = false
  state = {}
  constructor(props) {
    super(props)
    this.state = {
      modals: [
        { name: 'history', isOpen: false },
        { name: 'delete', isOpen: false, FullName: '', sourcing_id: '' },
      ],
      resultRFQ: {
        page: 1,
        limit: 10,
      },
      statuses: [],
      buyerList: [],
      awardStatuses: [],
      sealStatus: optionsSealStatus,
      eventTypes: [],
      eventTypeID: 0,
      listRFQ: [],
      eventName: '',
      buyerId: 0,
      awardId: 0,
      approvalStatus: 0,
      statusId: 0,
      searchPage: 1,
      activePage: 1,
      searchValue: '',
      buyerHistories: [],
      checkRole: '',
      checkMultiRole: '',
      roleCheckA: null,
      checkAwaiting: false,
      multiRoleCheck: null,
      workflowData: null,
      loaderHistory: false,
    }
    this.listDelete = ''
  }
  toggleModal = (evt, name, sourcing_id) => {
    if (this._isMounted) {
      return this.setState(prevState => ({
        ...prevState,
        modals: prevState.modals.map(modal => ({
          ...modal,
          isOpen: modal.name === evt ? !modal.isOpen : false,
          FullName: name,
          sourcing_id: sourcing_id,
        })),
      }))
    }
  }
  async getWorkflow(listRFQ = '') {
    let { workflowData } = this.state
    try {
      if (listRFQ) {
        const funRes = map(listRFQ, async (value, index) => {
          const { sourcing_id, event_type_id } = value
          let obj = null
          let resFlow = await eventNewController().getApproValWorkflow(
            sourcing_id
          )
          if (resFlow) {
            if (resFlow === '51510: approval work flow not found') {
              obj = {
                notFound: 'not found',
              }
              return obj
            } else {
              obj = resFlow
              return obj
            }
          }
        })
        const res = await Promise.all(funRes)
        if (res) {
          workflowData = res
          this.setState({ workflowData })
        }
      }
    } catch (error) {
      console.log(error)
    }
  }
  funcCheckCompareEvent(key = '') {
    const userIdFw = localStorage.getItem('buyerId')
    const userId = parseInt(userIdFw, 10)
    let { multiRoleCheck, workflowData } = this.state
    const approverMultiRole = find(multiRoleCheck, data => {
      return data.id === rolesObj.approver
    })
    if (workflowData && approverMultiRole) {
      const resultFlowData = workflowData[key]
      const checkTF = has(resultFlowData, 'notFound')
      const checkLevels = has(resultFlowData, 'levels')
      if (checkTF) {
        return false
      } else {
        if (checkLevels) {
          const { levels } = resultFlowData
          const filterArrLevels = map(levels, (value, index) => {
            const { approvers } = value
            const filterId = filter(approvers, value => {
              if (
                (value.id === userId && value.status === 1) ||
                (value.id === userId && value.status === 2) ||
                (value.id === userId && value.status === 3)
              ) {
                return value
              }
            })
            return filterId[0]
          })
          const removeUndefined = filter(
            filterArrLevels,
            value => value !== undefined
          )
          if (removeUndefined.length !== 0) {
            return true
          } else {
            return false
          }
        }
      }
    } else {
      return true
    }
  }
  // static getDerivedStateFromProps(props, state) {
  //   let { roleCheckA } = state
  //   let params = props.location.state
  //   if (params) {
  //     if (params.status) {
  //       const paramStatus = parseInt(params.status)
  //       store.dispatch(searchEventListAllStatus(paramStatus, true))
  //     } else if (params.awaitingunseal) {
  //       const paramAwaitingUnseal = parseInt(params.awaitingunseal)
  //       store.dispatch(searchEventListSealStatus(paramAwaitingUnseal, true))
  //     } else {
  //       const paramAward = parseInt(params.award)
  //       store.dispatch(searchEventListAllAward(paramAward, true))
  //     }
  //   }
  //   return null
  // }
  componentDidMount() {
    this._isMounted = true
    let { roleCheckA, checkAwaiting } = this.state
    const {
      search,
      enterSearch,
      selectedAllStatus,
      selectedSealStatus,
      selectedAwardStatus,
      selectedAllUser,
      status,
      sealStatus,
      allAward,
      allUser,
      page,
    } = this.props
    const notifyRequestUnseal = () => {
      const { messageReqUnseal } = this.props
      if (messageReqUnseal) {
        return toast.success(messageReqUnseal, {
          onClose: () => {
            store.dispatch(startApiRequestUnseal())
          },
        })
      }
    }
    const notifyRequestUnsealTec = () => {
      const { messageReqUnsealTec } = this.props
      if (messageReqUnsealTec) {
        if (messageReqUnsealTec === 'Cannot unseal by this user') {
          return toast.error(messageReqUnsealTec, {
            onClose: () => {
              store.dispatch(startApiRequestUnsealTec())
            },
          })
        } else if (messageReqUnsealTec === 'Event not ready to unseal') {
          return toast.error(messageReqUnsealTec, {
            onClose: () => {
              store.dispatch(startApiRequestUnsealTec())
            },
          })
        } else if (messageReqUnsealTec === 'Unsealed by Other TEC') {
          return toast.error(messageReqUnsealTec, {
            onClose: () => {
              store.dispatch(startApiRequestUnsealTec())
            },
          })
        } else {
          return toast.success(messageReqUnsealTec, {
            onClose: () => {
              store.dispatch(startApiRequestUnsealTec())
            },
          })
        }
      }
    }
    notifyRequestUnseal()
    notifyRequestUnsealTec()
    const params = this.props.location.state
    console.log('params.status', params)
    if (params) {
      const paramAward = parseInt(params.award)
      if (paramAward) {
        if (paramAward === 4) {
          checkAwaiting = true
          // if (params.amount > 0) {
          //   checkAwaiting = true
          // } else {
          //   checkAwaiting = false
          // }
        } else {
          checkAwaiting = false
        }
      }
    }
    // else {
    //   if (selectedAwardStatus) {
    //     checkAwaiting = true
    //   } else {
    //     checkAwaiting = false
    //   }
    // }
    if (
      enterSearch ||
      selectedAllStatus ||
      selectedSealStatus ||
      selectedAwardStatus ||
      selectedAllUser ||
      page
    ) {
      this.getListRFQ(page)
    } else {
      if (params) {
        if (params.status) {
          console.log('paramStatus', paramStatus)
          const paramStatus = parseInt(params.status)
          const paramsbuyerId = params.buyerId
          store.dispatch(searchEventListAllStatus(paramStatus, true))
          store.dispatch(searchEventListAllUser(paramsbuyerId, true))
          this.getListRFQDefault(params.status, 0, 0, paramsbuyerId)
        } else if (params.awaitingunseal) {
          console.log('paramAward', params)
          const paramAwaitingUnseal = parseInt(params.awaitingunseal)
          store.dispatch(searchEventListSealStatus(paramAwaitingUnseal, true))
          this.getListRFQDefault(0, 0, params.awaitingunseal, 0, true)
        } else {
          const paramAward = parseInt(params.award)
          console.log('paramAward', paramAward)
          const paramsbuyerId = params.buyerId
          store.dispatch(searchEventListAllAward(paramAward, true))
          store.dispatch(searchEventListAllUser(paramsbuyerId, true))
          this.getListRFQDefault(0, params.award, 0, paramsbuyerId)
        }
      } else {
        this.getListRFQDefault()
      }
    }
    this.getEventStatus()
    this.getEventAwardStatus()
    this.getRFQBuyerList()
    this.getEventTypes()
    const roles = pageSourcingBuyerController().asset()
    const multiRole = pageSourcingBuyerController().getMultiRole()
    const multiRoleApr = pageSourcingBuyerController().getMultiRoleApp()
    let { multiRoleCheck } = this.state
    multiRoleCheck = pageSourcingBuyerController().getMultiRoleApp()
    const findRolesApr = find(
      multiRoleApr,
      value => value.id === rolesObj.approver
    )
    roleCheckA = findRolesApr
    this.setState({
      checkRole: roles,
      checkMultiRole: multiRole,
      roleCheckA,
      checkAwaiting,
      multiRoleCheck,
    })
  }
  componentWillUnmount() {
    this._isMounted = false
  }
  getEventStatus = async () => {
    const res = await eventNewController().getEventStatus()
    if (res) {
      let option = []
      res.map(e => {
        const data = { value: parseInt(e.id), label: e.name }
        option.push(data)
      })
      if (this._isMounted) {
        return this.setState({ statuses: option })
      }
    }
  }
  getRFQBuyerList = async () => {
    const res = await rfqController().getBuyerList()
    if (res) {
      let option = []
      res.map(e => {
        const data = { value: parseInt(e.id), label: e.full_name }
        option.push(data)
      })
      if (this._isMounted) {
        return this.setState({ buyerList: option })
      }
    }
  }

  getEventAwardStatus = async () => {
    const res = await eventNewController().getEventAwardStatus()
    if (res) {
      let option = []
      res.map(e => {
        const data = { value: parseInt(e.id), label: e.name }
        option.push(data)
      })
      if (this._isMounted) {
        return this.setState({ awardStatuses: option })
      }
    }
  }
  getEventTypes = async () => {
    const res = await rfqController().getEventTypes()
    // Mockup data pending API
    const options = [
      {
        value: 0,
        label: 'All Event Type',
      },
      {
        value: 1,
        label: 'RFQ',
      },
      {
        value: 2,
        label: 'Auction',
      },
    ]
    if (res) {
      let option = []
      res.map(e => {
        const data = { value: e.ID, label: e.name }
        option.push(data)
      })
      if (this._isMounted) {
        // return this.setState({ eventTypes: option })
        return this.setState({ eventTypes: options })
      }
    }
  }

  getListRFQ = async (
    page,
    paramsStatus = '',
    paramsAward = '',
    paramsSealStatus = ''
  ) => {
    const {
      resultRFQ,
      eventName,
      awardId,
      statusId,
      approvalStatus,
      buyerId,
    } = this.state
    const {
      search,
      status,
      sealStatus,
      allAward,
      allUser,
      eventTypeID,
    } = this.props
    const newApprovalStatus = allAward === 4 ? 1 : approvalStatus
    const params = {
      limit: resultRFQ.limit,
      page: page ? page : resultRFQ.page,
      createById: allUser,
      eventName: search.trim(),
      awardId: paramsAward ? paramsAward : allAward,
      statusId: paramsStatus ? paramsStatus : status,
      seal_status_id: paramsSealStatus ? paramsSealStatus : sealStatus,
      approvalStatusId: this.state.checkAwaiting ? 1 : 0, // newApprovalStatus เก่า
      requested_unseal: false,
      event_type_id: eventTypeID,
      just_for_me: this.state.checkAwaiting,
    }
    const res = await rfqController().getListRFQEventSourcing(params)
    if (res) {
      // this.getWorkflow(res.records)
      if (this._isMounted) {
        store.dispatch(filterPageAllEvent(page ? page : resultRFQ.page, true))
        this.setState({
          resultRFQ: res,
          listRFQ: res.records,
          activePage: page ? page : resultRFQ.page,
        })
      }
    } else {
      toastFail('error')
    }
  }
  getListRFQDefault = async (
    status = 0,
    award = 0,
    sealStatus = 0,
    paramsbuyerId = 0,
    requested_unseal = false
  ) => {
    const { resultRFQ, checkAwaiting, buyerId } = this.state
    const role = localStorage.getItem('userData')
    const approvalStatus = award === 4 ? 1 : 0
    const checkForMe = award === 4 ? true : checkAwaiting
    const params = {
      limit: resultRFQ.limit,
      page: resultRFQ.page,
      createById: buyerId ? buyerId : paramsbuyerId,
      eventName: '',
      awardId: award,
      statusId: status,
      seal_status_id: sealStatus,
      approvalStatusId: checkForMe ? 1 : 0, // approvalStatus, //เก่า
      requested_unseal:
        role.includes('admin') || role.includes('Admin') // บางไซต์หลังบ้านส่งมาเป็น admin / Admin
          ? false
          : requested_unseal, // requested_unseal ? requested_unseal : false // เก่า
      event_type_id: this.props.eventTypeID,
      just_for_me:
        role.includes('admin') || role.includes('Admin')
          ? false
          : requested_unseal || checkForMe,
    }
    const res = await rfqController().getListRFQEventSourcing(params)
    if (res) {
      if (this._isMounted) {
        // this.getWorkflow(res.records)
        this.setState({ resultRFQ: res, listRFQ: res.records })
      }
    } else {
      toastFail('error')
    }
  }
  filterSupplierListStatusCancel = (suppliers = [], statusId = '') => {
    const filterIsCancel = suppliers.filter(data => {
      const eventCancel = data.is_cancel && (statusId === 5 || statusId === 0)
      const eventNotCancel = !data.is_cancel && statusId !== 5
      if (eventCancel) {
        return data
      } else if (eventNotCancel) {
        return data
      }
    })
    return filterIsCancel
  }

  onClickDelete = async id => {
    const res = await rfqController().deleteRFQ(id)
    if (res) {
      this.getListRFQ()
      toastActive('Event was delete')
      this.toggleModal()
    } else {
      toastFail('error')
    }
  }

  matchValueSelected = (option, selectedId) => {
    return option.find(
      value => value.value.toString() === selectedId.toString()
    )
  }

  matchValue = (option, selectedId) => {
    const matchOption = option.find(
      value => value.value.toString() === selectedId.toString()
    )
    if (matchOption) {
      return matchOption.label
    }
  }
  matchValueSealStatus = (option, selectedLabel) => {
    const matchOption = option.find(value => value.label === selectedLabel)
    if (matchOption) {
      return matchOption.label
    }
  }
  renderSealStatusText = (options, values) => {
    const objectText = {
      awaiting: 'Awaiting Unseal',
      unsealed: 'Unsealed',
      sealed: 'Sealed',
    }
    if (values) {
      if (values === objectText.awaiting) {
        return (
          <React.Fragment>
            <p className="seal-status-awaiting">
              {this.matchValueSealStatus(options, values)}
            </p>
          </React.Fragment>
        )
      } else if (values === objectText.unsealed) {
        return (
          <React.Fragment>
            <p className="seal-status-unsealed">
              {this.matchValueSealStatus(options, values)}
            </p>
          </React.Fragment>
        )
      } else if (values === objectText.sealed) {
        return (
          <React.Fragment>
            <p className="seal-status-sealed">
              {this.matchValueSealStatus(options, values)}
            </p>
          </React.Fragment>
        )
      }
      return values
    }
    return '-'
  }
  changePage = e => {
    this.getListRFQ(e)
    if (this._isMounted) {
      return this.setState({ activePage: e })
    }
  }

  copyRfqByID = data => {
    const { match, history } = this.props
    const { eventButton, eventId, event_type_id, id, rfqId } = data
    const linkEvent = `/sourcing-detail-form-buyer-cocr/${id}/${eventId}`
    // const linkEvent = `/sourcing-detail-form-buyer-cocr/${id}/${rfqId}`
    return history.push(linkEvent)
  }

  getHistoriesByID = async event_id => {
    this.setState({ loaderHistory: true })
    try {
      if (event_id) {
        let res = await eventNewController().eventHistories(event_id)

        if (res) {
          if (this._isMounted) {
            this.setState({ buyerHistories: res, loaderHistory: false })
          }
        }
      }
    } catch (error) {
      throw error
    }
  }

  downloadCompareToExcel = info => {
    if (info.event_type_id === 1) {
      return rfqController()
        .downloadCompareToExcel(info.sourcing_id)
        .then(res => FileDownload(res.data, info.sourcing_name + '.xlsx'))
    }
    if (info.event_type_id === 2) {
      return auctionController()
        .downloadCompareToExcel(info.sourcing_id)
        .then(res => FileDownload(res.data, info.sourcing_name + '.xlsx'))
    }
  }

  onClickOpenRfqHistory = e => {
    this.getHistoriesByID(e.event_id)
    this.toggleModal('history', e.sourcing_name, e.sourcing_id)
  }

  onCloseModalHistory = () => {
    this.toggleModal()
    if (this._isMounted) {
      return this.setState({ rfqHistories: [] })
    }
  }

  listRole = (roles = []) => {
    if (roles.length > 0) {
      return (
        <React.Fragment>
          <div>
            {roles.map((v, i) => {
              return <p key={v.id}>{v.name}</p>
            })}
          </div>
        </React.Fragment>
      )
    }
  }

  renderStartDateEndDate = (date = {}) => {
    return (
      <Section>
        ( Start date: {dateMonDayYearTime(date.start_date)}
        <br />
        End date: {dateMonDayYearTime(date.end_date)} )
      </Section>
    )
  }

  rfqHistoryReopenRescheduleShowStartDateEndDate = (rh = {}) => {
    const reOpen = rh.action_history_type_id === 11
    const reSchedule = rh.action_history_type_id === 12

    if (reOpen || reSchedule) {
      const date = {
        start_date: rh.start_date,
        end_date: rh.end_date,
      }
      return this.renderStartDateEndDate(date)
    }
  }

  renderRfqHistories = (rfqHistories = []) => {
    return rfqHistories.map((rh, i) => {
      const reject = rh.action_history_type_id === 9
      const isSupplierAccount = rh.by_main_role_id === 3
      const isSystemReject = rh.action_history_type.includes('Reject')
        ? rh.roles.findIndex(r => r.name === 'System') > -1
          ? true
          : false
        : false
      const funcRenderActionHistoryType = () => {
        if (rh.action_history_type.includes('Reject') && !isSystemReject) {
          return <Section>Reason: {rh.cancel_reason}</Section>
        } else {
          return ''
        }
      }
      return (
        <Table.TR key={i}>
          <Table.TD className="create-date">
            {dateMonDayYearTime(rh.created_at)}
          </Table.TD>

          <Table.TD className="detail">
            <Section>{rh.action_history_type}</Section>
            {funcRenderActionHistoryType()}
            {this.rfqHistoryReopenRescheduleShowStartDateEndDate(rh)}
          </Table.TD>

          <Table.TD className="action">
            <Section> {rh.action_by}</Section>
            <Section>
              {isSupplierAccount
                ? rh.supplier_company_name
                : this.listRole(rh.roles)}
            </Section>
          </Table.TD>
        </Table.TR>
      )
    })
  }

  onClickClearSearch = () => {
    const DEFAULT_PAGE = 1
    store.dispatch(searchEventListSearch())
    if (this._isMounted) {
      return this.setState({ activePage: DEFAULT_PAGE }, () => {
        this.getListRFQ(DEFAULT_PAGE)
      })
    }
  }
  renderIconExport = (data, rolesTec) => {
    const { checkRole, checkMultiRole } = this.state
    const purchaserMultiRole = find(checkMultiRole, dataValue => {
      return dataValue.id === rolesObj.purchaser
    })
    const approverMultiRole = find(checkMultiRole, data => {
      return data.id === rolesObj.approver
    })
    const tecMultiRole = find(checkMultiRole, data => {
      return data.id === rolesObj.tec
    })
    const renderExport = () => {
      if (
        data.sourcing_seal_status !== '' &&
        data.sourcing_status === 4 &&
        data.sourcing_seal_status !== 'Awaiting Unseal' &&
        data.sourcing_seal_status !== 'Sealed'
      ) {
        return (
          <React.Fragment>
            <Button
              className="link"
              onClick={() => {
                this.downloadCompareToExcel(data)
              }}
            >
              <Image
                className="export-icon"
                src={ICONS['icon-export.svg']}
                alt="export"
                tootipValue={`Export`}
                useTootipFor="Export"
                useTootip={true}
              />
            </Button>
          </React.Fragment>
        )
      } else if (
        data.sourcing_seal_status !== '' &&
        data.sourcing_status === 5 &&
        data.sourcing_seal_status !== 'Awaiting Unseal' &&
        data.sourcing_seal_status !== 'Sealed'
      ) {
        return (
          <React.Fragment>
            <Button
              className="link"
              onClick={() => {
                this.downloadCompareToExcel(data)
              }}
            >
              <Image
                className="export-icon"
                src={ICONS['icon-export.svg']}
                alt="export"
                tootipValue={`Export`}
                useTootipFor="Export"
                useTootip={true}
              />
            </Button>
          </React.Fragment>
        )
      } else if (
        data.sourcing_seal_status == '' &&
        (data.sourcing_status === 4 || data.sourcing_status === 5)
      ) {
        return (
          <React.Fragment>
            <Button
              className="link"
              onClick={() => {
                this.downloadCompareToExcel(data)
              }}
            >
              <Image
                className="export-icon"
                src={ICONS['icon-export.svg']}
                alt="export"
                tootipValue={`Export`}
                useTootipFor="Export"
                useTootip={true}
              />
            </Button>
          </React.Fragment>
        )
      } else if (data.sourcing_seal_status == '' && data.is_cancel === true) {
        return (
          <React.Fragment>
            <Button
              className="link"
              onClick={() => {
                this.downloadCompareToExcel(data)
              }}
            >
              <Image
                className="export-icon"
                src={ICONS['icon-export.svg']}
                alt="export"
                tootipValue={`Export`}
                useTootipFor="Export"
                useTootip={true}
              />
            </Button>
          </React.Fragment>
        )
      }
    }
    if (
      checkRole === rolesObj.admin ||
      checkRole === rolesObj.systemadmin ||
      checkRole === rolesObj.purchaser ||
      checkRole === rolesObj.approver
    ) {
      return renderExport()
    } else {
      // fix bug roles export event to excel
      // admin | Purchaser | Approver
      if (purchaserMultiRole || approverMultiRole) {
        return renderExport()
      }
    }
  }
  renderSourcingList = () => {
    const {
      modals,
      resultRFQ,
      activePage,
      listRFQ,
      eventName,
      statuses,
      buyerList,
      awardStatuses,
      eventTypes,
      buyerId,
      statusId,
      awardId,
      sealStatus,
      approvalStatus,
    } = this.state
    const idRoleTec = 10
    const someArrayCheckRole = element => {
      return element.id !== idRoleTec
    }
    let hideTecRole = null
    const isEmpty = obj => {
      if (typeof obj == 'number') return false
      else if (typeof obj == 'string') return obj.length == 0
      else if (Array.isArray(obj)) return obj.length == 0
      else if (typeof obj == 'object')
        return obj == null || Object.keys(obj).length == 0
      else if (typeof obj == 'boolean') return false
      else return !obj
    }
    const checkEmptyRole = isEmpty(this.props.user)
    if (checkEmptyRole === false) {
      hideTecRole = this.props.user.roles.some(someArrayCheckRole)
    }
    const pageTitle = () => {
      const handlerClickBreadcrumb = e => {
        return this.props.history.push(ROUTE_PATH.HOME.LINK)
      }
      const funcButtonBack = () => {
        const handlersClick = e => {
          if (e.detail === 1) {
            store.dispatch(filterPageAllEvent(1, true))
            return this.props.history.push(ROUTE_PATH.SOURCING_PROJECTS.LINK)
          }
        }
        return (
          <Section className="page-button">
            <Button
              className="theme-border-gray page-button"
              onClick={handlersClick}
            >
              Back
            </Button>
          </Section>
        )
      }
      return (
        <Section className="page-topbar">
          <Section className="page-header">
            <Section className="page-icon">
              <Image
                id="page_icon_user_management"
                src={ICONS['icon-sourcing-white.svg']}
                alt="page icon"
              />
            </Section>
            <Section className="title-and-breadcrumb">
              <Section id="page_title_user_management" className="title">
                Sourcing
              </Section>
              <Breadcrumbs props={this.props} />
            </Section>
          </Section>
          {funcButtonBack()}
        </Section>
      )
    }
    const renderPageContent = () => {
      const funcOnKeyDownSearchInput = e => {
        if (e.keyCode == 13) {
          store.dispatch(searchEventListSearch(e.target.value, true))
          return this.getListRFQ(1)
        }
      }
      const funcOnChangeSearchInput = e => {
        return store.dispatch(searchEventListSearch(e.target.value))
      }
      const funconClickSearchSearchInput = e => {
        return this.onClickClearSearch()
      }
      const funcOnChangeEvenStatusFilter = event => {
        resultRFQ.page = 1
        store.dispatch(searchEventListAllStatus(event.value, true))
        if (this._isMounted) {
          return this.setState({ resultRFQ }, this.getListRFQ)
        }
      }
      const funcOnChangeEventTypeFilter = event => {
        resultRFQ.page = 1
        store.dispatch(searchEventListAllEventType(event.value, true))
        if (this._isMounted) {
          return this.setState({ resultRFQ }, this.getListRFQ)
        }
      }
      const funcOnChangeSealStatusFilter = event => {
        resultRFQ.page = 1
        store.dispatch(searchEventListSealStatus(event.value, true))
        if (this._isMounted) {
          return this.setState({ resultRFQ }, this.getListRFQ)
        }
      }
      const funcOnChangeAwardStatusFilter = event => {
        let { checkAwaiting, approvalStatus } = this.state
        resultRFQ.page = 1
        if (event.value !== 4) {
          approvalStatus = 0
          checkAwaiting = false
        }
        store.dispatch(searchEventListAllAward(event.value, true))
        if (this._isMounted) {
          return this.setState(
            {
              resultRFQ,
              checkAwaiting,
              approvalStatus,
            },
            this.getListRFQ
          )
        }
      }
      const funcOnChangeCreateStatusFilter = event => {
        resultRFQ.page = 1
        store.dispatch(searchEventListAllUser(event.value, true))
        if (this._isMounted) {
          return this.setState({ resultRFQ }, this.getListRFQ)
        }
      }
      const funcListRFQ = () => {
        if (listRFQ) {
          const funcEmployeeType = e => {
            if (e.event_type_id) {
              return this.matchValue(eventTypes, e.event_type_id)
            } else {
              return null
            }
          }
          const funcStartDate = e => {
            if (e.start_date === '0001-01-01T00:00:00Z') {
              return 'N/A'
            } else {
              return dateMonDayYearTime(e.start_date)
            }
          }
          const funcEndDate = e => {
            if (e.end_date === '0001-01-01T00:00:00Z') {
              return 'N/A'
            } else {
              return dateMonDayYearTime(e.end_date)
            }
          }
          const funcActiveStatus = e => {
            if (e.is_cancel) {
              return <p className={`inactive-status`}>Cancelled</p>
            } else {
              if (e.sourcing_status) {
                return (
                  <p
                    className={
                      e.sourcing_status === 1 || e.sourcing_status === 2
                        ? `pending-status`
                        : e.sourcing_status === 3
                        ? `success-status`
                        : `info-status`
                    }
                  >
                    {this.matchValue(statuses, e.sourcing_status)}
                  </p>
                )
              } else {
                return null
              }
            }
          }
          const funcAwardStatus = e => {
            if (e.sourcing_award_status && e.sourcing_award_status != 0) {
              return (
                <p
                  className={
                    e.sourcing_award_status === 1
                      ? ``
                      : e.sourcing_award_status === 3 ||
                        e.sourcing_award_status === 4
                      ? `pending-status`
                      : e.sourcing_award_status === 2 ||
                        e.sourcing_award_status === 5 ||
                        e.sourcing_award_status === 8
                      ? `info-status`
                      : e.sourcing_award_status === 6
                      ? `success-status`
                      : e.sourcing_award_status === 7 && `rejected-status`
                  }
                >
                  {this.matchValue(awardStatuses, e.sourcing_award_status)}
                </p>
              )
            } else {
              return 'N/A'
            }
          }
          const actionsEdit = e => {
            const { sourcing_status, sourcing_project_id, event_id } = e
            const linkEdit = `sourcing-detail-form-event-buyer/${sourcing_project_id}/${event_id}`
            const renderButton = () => {
              const { checkRole, checkMultiRole } = this.state
              const MultiRole = find(checkMultiRole, data => {
                return (
                  data.id === rolesObj.purchaser ||
                  data.id === rolesObj.observer
                )
              })
              const handlerClickEdit = e => {
                localStorage.setItem('isFromDetail', 'false2')
                if (e.detail === 1) {
                  return this.props.history.push(linkEdit)
                }
              }
              // check ว่าเป็น Single Roles
              if (
                checkRole === rolesObj.admin ||
                checkRole === rolesObj.systemadmin ||
                checkRole === rolesObj.purchaser ||
                checkRole === rolesObj.observer
              ) {
                return (
                  <Button className="link" onClick={handlerClickEdit}>
                    <Image
                      className="edit-icon"
                      src={ICONS['icon-edit.svg']}
                      alt="edit"
                      tootipValue={`View/Edit`}
                      useTootipFor="Edit"
                      useTootip={true}
                    />
                  </Button>
                )
              } else {
                // check ว่าเป็น Multiple role
                if (MultiRole) {
                  return (
                    <Button className="link" onClick={handlerClickEdit}>
                      <Image
                        className="edit-icon"
                        src={ICONS['icon-edit.svg']}
                        alt="edit"
                        tootipValue={`Edit`}
                        useTootipFor="Edit"
                        useTootip={true}
                      />
                    </Button>
                  )
                }
              }
            }
            if (sourcing_status === 1) {
              return renderButton()
            }
          }
          const actionscompareEvent = (e, key) => {
            const { multiRoleCheck } = this.state
            const {
              sourcing_award_status,
              sourcing_seal_status,
              sourcing_status,
              approval_status,
              sourcing_project_id,
              sourcing_id,
              sourcing_seal_type,
              event_type_id,
            } = e
            const checkFlow = this.funcCheckCompareEvent(key)
            const linkComPareEvent = `/sourcing-compare-event/${sourcing_project_id}/${sourcing_id}/${event_type_id}`
            const awaitingSelection = 3
            const awaitingUnseal = 'Awaiting Unseal'
            const awaitingButtonCompare = () => {
              const adminMultiRole = find(multiRoleCheck, data => {
                return data.id === rolesObj.admin
              })
              const systemMultiRole = find(multiRoleCheck, data => {
                return data.id === rolesObj.systemadmin
              })
              const purchaserMultiRole = find(multiRoleCheck, data => {
                return data.id === rolesObj.purchaser
              })
              const tecMultiRole = find(multiRoleCheck, data => {
                return data.id === rolesObj.tec
              })
              const approverMultiRole = find(multiRoleCheck, data => {
                return data.id === rolesObj.approver
              })
              const obsMultiRole = find(multiRoleCheck, data => {
                return data.id === rolesObj.observer
              })
              if (sourcing_status !== 1) {
                if (
                  tecMultiRole &&
                  sourcing_seal_type &&
                  sourcing_seal_status === 'Unsealed' &&
                  sourcing_status !== 4
                ) {
                  return (
                    <Button
                      className="link"
                      onClick={() => {
                        localStorage.setItem('isFromDetail', false)
                        this.props.history.push(linkComPareEvent)
                      }}
                    >
                      <Image
                        className="compare-icon"
                        src={ICONS['icon-compare.svg']}
                        alt="compare"
                        tootipValue={`Compare`}
                        useTootipFor="Compare"
                        useTootip={true}
                      />
                    </Button>
                  )
                } else if (
                  tecMultiRole ||
                  adminMultiRole ||
                  systemMultiRole ||
                  purchaserMultiRole ||
                  obsMultiRole ||
                  (approverMultiRole && checkFlow)
                ) {
                  return (
                    <Button
                      className="link"
                      onClick={() => {
                        localStorage.setItem('isFromDetail', false)
                        this.props.history.push(linkComPareEvent)
                      }}
                    >
                      <Image
                        className="compare-icon"
                        src={ICONS['icon-compare.svg']}
                        alt="compare"
                        tootipValue={`Compare`}
                        useTootipFor="Compare"
                        useTootip={true}
                      />
                    </Button>
                  )
                }
              }
            }
            return awaitingButtonCompare()
          }
          const funcCopyRfqByID = e => {
            const {
              event_id,
              sourcing_project_id,
              sourcing_id,
              event_type_id,
            } = e
            const { checkRole, checkMultiRole } = this.state
            const purchaserMultiRole = find(checkMultiRole, data => {
              return data.id === rolesObj.purchaser
            })
            if (
              checkRole === rolesObj.admin ||
              checkRole === rolesObj.systemadmin ||
              checkRole === rolesObj.purchaser
            ) {
              return (
                <Button
                  className="link"
                  onClick={e => {
                    const objectData = {
                      id: sourcing_project_id,
                      rfqId: sourcing_id,
                      eventId: event_id,
                      eventButton: e,
                      event_type_id,
                    }
                    if (e.detail === 1) {
                      this.copyRfqByID(objectData)
                    }
                  }}
                >
                  <Image
                    className="paste-icon"
                    src={ICONS['icon-paste.svg']}
                    alt="copy"
                    tootipValue={`Copy`}
                    useTootipFor="Copy"
                    useTootip={true}
                  />
                </Button>
              )
            } else {
              if (purchaserMultiRole) {
                console.log('multi')
                return (
                  <Button
                    className="link"
                    // onClick={() => {
                    //   this.copyRfqByID(event_id, sourcing_project_id)
                    // }}
                    onClick={e => {
                      const objectData = {
                        id: sourcing_project_id,
                        rfqId: sourcing_id,
                        eventId: event_id,
                        eventButton: e,
                        event_type_id,
                      }
                      this.copyRfqByID(objectData)
                    }}
                  >
                    <Image
                      className="paste-icon"
                      src={ICONS['icon-paste.svg']}
                      alt="copy"
                      tootipValue={`Copy`}
                      useTootipFor="Copy"
                      useTootip={true}
                    />
                  </Button>
                )
              }
            }
          }
          const handlerActionsLinkClick = e => {
            return this.onClickOpenRfqHistory(e)
          }
          const funcRenderHistory = e => {
            const { multiRoleCheck } = this.state
            const adminMultiRole = find(multiRoleCheck, data => {
              return data.id === rolesObj.admin
            })
            const systemMultiRole = find(multiRoleCheck, data => {
              return data.id === rolesObj.systemadmin
            })
            const purchaserMultiRole = find(multiRoleCheck, data => {
              return data.id === rolesObj.purchaser
            })
            const tecMultiRole = find(multiRoleCheck, data => {
              return data.id === rolesObj.tec
            })
            const approverMultiRole = find(multiRoleCheck, data => {
              return data.id === rolesObj.approver
            })
            const obsMultiRole = find(multiRoleCheck, data => {
              return data.id === rolesObj.observer
            })
            if (
              adminMultiRole ||
              systemMultiRole ||
              tecMultiRole ||
              obsMultiRole ||
              purchaserMultiRole ||
              tecMultiRole ||
              approverMultiRole
            ) {
              return (
                <Button
                  className="link"
                  onClick={() => {
                    handlerActionsLinkClick(e)
                  }}
                >
                  <Image
                    className="history-icon"
                    src={ICONS['icon-history.svg']}
                    alt="history"
                    tootipValue={`History`}
                    useTootipFor="History"
                    useTootip={true}
                  />
                </Button>
              )
            }
          }
          const funcDelete = e => {
            const { sourcing_status } = e
            const renderButtonDelete = () => {
              const { checkRole, checkMultiRole } = this.state
              const purchaserMultiRole = find(checkMultiRole, data => {
                return data.id === rolesObj.purchaser
              })
              if (
                checkRole === rolesObj.admin ||
                checkRole === rolesObj.systemadmin ||
                checkRole === rolesObj.purchaser
              ) {
                return (
                  <Button
                    className="link"
                    onClick={() => {
                      this.toggleModal(
                        'delete',
                        e.sourcing_name,
                        e.sourcing_id
                      ),
                        (this.listDelete = e.sourcing_id)
                      document.body.classList.add('modal-open')
                    }}
                  >
                    <Image
                      className="delete-icon"
                      src={ICONS['icon-trash.svg']}
                      alt="delete"
                      tootipValue={`Delete`}
                      useTootipFor="Delete"
                      useTootip={true}
                    />
                  </Button>
                )
              } else {
                if (purchaserMultiRole) {
                  return (
                    <Button
                      className="link"
                      onClick={() => {
                        this.toggleModal(
                          'delete',
                          e.sourcing_name,
                          e.sourcing_id
                        ),
                          (this.listDelete = e.sourcing_id)
                        document.body.classList.add('modal-open')
                      }}
                    >
                      <Image
                        className="delete-icon"
                        src={ICONS['icon-trash.svg']}
                        alt="delete"
                        tootipValue={`Delete`}
                        useTootipFor="Delete"
                        useTootip={true}
                      />
                    </Button>
                  )
                }
              }
            }
            if (sourcing_status === 1) {
              return renderButtonDelete()
            }
          }
          const funcRenderButtonAuction = e => {
            if (e.event_type_string === 'Auction') {
              return (
                <Button
                  className="link"
                  onClick={() => {
                    this.props.history.push(
                      `/sourcing-auction-buyer/${e.sourcing_id}`
                    )
                  }}
                >
                  <Image
                    className="Auction-icon"
                    src={ICONS['icon-hammer-blue.svg']}
                    alt="Auction"
                    tootipValue={`Auction`}
                    useTootipFor="Auction"
                    useTootip={true}
                  />
                </Button>
              )
            } else {
              return null
            }
          }
          return listRFQ.map((e, i) => {
            return (
              <Table.TR key={i}>
                <Table.TD className="event-no">
                  <Text
                    tootipValue={e.code}
                    useTootipFor="code"
                    useTootip={true}
                  >
                    {e.code}
                  </Text>
                </Table.TD>
                <Table.TD className="event-name">
                  <Text
                    tootipValue={e.sourcing_name}
                    useTootipFor="sourcing-name"
                    useTootip={true}
                  >
                    {e.sourcing_name}
                  </Text>
                </Table.TD>
                <Table.TD className="employee-type">
                  {funcEmployeeType(e)}
                </Table.TD>
                <Table.TD className="start-date">{funcStartDate(e)}</Table.TD>
                <Table.TD className="end-date">{funcEndDate(e)}</Table.TD>
                <Table.TD className="active-status">
                  {funcActiveStatus(e)}
                </Table.TD>
                <Table.TD className="seal-status">
                  <React.Fragment>
                    {this.renderSealStatusText(
                      sealStatus,
                      e.sourcing_seal_status
                    )}
                  </React.Fragment>
                </Table.TD>
                <Table.TD className="award-status">
                  {funcAwardStatus(e)}
                </Table.TD>
                <Table.TD className="created-by">
                  <Text
                    tootipValue={e.created_by_string}
                    useTootipFor="created-by-string"
                    useTootip={true}
                  >
                    {e.created_by_string}
                  </Text>
                </Table.TD>
                <Table.TD className="actions">
                  <Section>
                    {e.sourcing_status === 3 && funcRenderButtonAuction(e)}
                    {actionsEdit(e)}
                    {actionscompareEvent(e, i)}
                    {funcCopyRfqByID(e)}
                    {funcRenderHistory(e)}
                    {this.renderIconExport(e, hideTecRole)}
                    {funcDelete(e)}
                  </Section>
                </Table.TD>
              </Table.TR>
            )
          })
        }
      }
      const resultFound = () => {
        if (isEmpty(listRFQ)) {
          if (this.state.activePage > 1) {
            this.getListRFQ(this.state.activePage - 1)
          }
          return (
            <Table.TBODY>
              <Table.TR>
                <Table.TD>
                  <Section className="no-result-found">
                    <Image src={ICONS['icon-ssr.png']} className="no-result" />
                    <p>No result found</p>
                  </Section>
                </Table.TD>
              </Table.TR>
            </Table.TBODY>
          )
        }
      }
      const showinglistRFQItem = () => {
        if (isEmpty(listRFQ)) {
          return '0'
        } else {
          if (resultRFQ.offset === 0) {
            return '1'
          } else {
            return resultRFQ.offset + 1
          }
        }
      }
      const showinglistRFQItemLimit = () => {
        const limit = resultRFQ.offset + resultRFQ.limit
        if (limit > resultRFQ.total_record) {
          return resultRFQ.total_record
        } else {
          return limit
        }
      }
      const onChangeNumberFormat = e => {
        if (this._isMounted) {
          return this.setState({ searchPage: parseInt(e.target.value) })
        }
      }
      const isAllowedNumberFormat = values => {
        const { value, floatValue } = values
        if (value == 0 && value !== '') {
          return false
        } else if (
          typeof floatValue === 'undefined' ||
          typeof value === 'undefined'
        ) {
          return true
        } else if (value.charAt(0) === '0') {
          if (value.charAt(1) && value.charAt(1) != '.') {
            return false
          }
        } else if (this.props.maximum) {
          return floatValue <= this.props.maximum
        } else {
          return true
        }
      }
      const onClickGo = e => {
        return this.changePage(this.state.searchPage)
      }
      const onChangePaginate = e => {
        return this.changePage(e)
      }
      const handlersChange = e => {
        let { checkAwaiting, resultRFQ } = this.state
        resultRFQ.page = 1
        this.setState({
          approvalStatus: e.target.checked === false ? 0 : 1,
        })
        store.dispatch(
          searchEventListAllAward(e.target.checked === false ? 0 : 4, true)
        )
        this.setState(
          { checkAwaiting: !checkAwaiting, resultRFQ },
          this.getListRFQ
        )
      }
      const renderCheckboxApprove = () => {
        let { roleCheckA, checkAwaiting } = this.state
        if (roleCheckA) {
          return (
            <Fragment>
              <Checkbox
                id="checkbox_check"
                value="3"
                otherProps
                checked={checkAwaiting}
                style={{ width: 'auto' }}
                onChange={handlersChange}
              />
              <Input
                id="filter_search_input_check"
                name="searchValue"
                value="Awaiting Approve"
                className="search_input_check"
              />
            </Fragment>
          )
        }
      }
      const funStyleRoleCheckA = () => {
        const { roleCheckA } = this.state
        if (roleCheckA) {
          return {
            minWidth: '170px',
          }
        } else {
          return {}
        }
      }
      return (
        <Section className="main-content">
          <Section className="content-body">
            <Section className="table-filter">
              {renderCheckboxApprove()}
              <InputSearch
                id="filter_search_input"
                placeholder="Event No., Event Name"
                name="searchValue"
                clear={'true'}
                onKeyDown={funcOnKeyDownSearchInput}
                onChange={funcOnChangeSearchInput}
                onClickSearchClear={funconClickSearchSearchInput}
                value={this.props.search}
              />
              {this.state.checkRole !== 10 && (
                <SelectBox
                  id="event_type_filter"
                  className="table-filter"
                  options={eventTypes}
                  placeholder="All Event Type"
                  isSearchable={false}
                  isClearable={false}
                  value={this.matchValueSelected(
                    eventTypes,
                    this.props.eventTypeID
                  )}
                  onChange={funcOnChangeEventTypeFilter}
                  style={funStyleRoleCheckA()}
                />
              )}
              <SelectBox
                id="even_status_filter"
                className="table-filter"
                options={statuses}
                placeholder="All Event Status"
                isSearchable={false}
                isClearable={false}
                value={this.matchValueSelected(statuses, this.props.status)}
                onChange={funcOnChangeEvenStatusFilter}
                style={funStyleRoleCheckA()}
              />
              <SelectBox
                id="seal_status_filter"
                className="table-filter"
                options={sealStatus}
                placeholder="All Seal Status"
                isSearchable={false}
                isClearable={false}
                value={this.matchValueSelected(
                  sealStatus,
                  this.props.sealStatus
                )}
                onChange={funcOnChangeSealStatusFilter}
                style={funStyleRoleCheckA()}
              />
              <SelectBox
                id="award_status_filter"
                className="table-filter"
                options={awardStatuses}
                placeholder="All Award Status"
                isSearchable={false}
                isClearable={false}
                value={this.matchValueSelected(
                  awardStatuses,
                  this.props.allAward
                )}
                onChange={funcOnChangeAwardStatusFilter}
                style={funStyleRoleCheckA()}
              />
              <SelectBox
                id="create_status_filter"
                className="table-filter"
                options={buyerList}
                placeholder="Created By"
                isSearchable={false}
                isClearable={false}
                value={this.matchValueSelected(buyerList, this.props.allUser)}
                onChange={funcOnChangeCreateStatusFilter}
                style={funStyleRoleCheckA()}
              />
            </Section>
            <Section mb={'2rem'} className="table-wrapper">
              <Table className="user split-row-color">
                {/* Header Row */}
                <Table.THEAD>
                  <Table.TR className="header">
                    <Table.TH className="event-no" id="event_no">
                      EVENT NO.
                    </Table.TH>
                    <Table.TH className="event-name" id="event_name">
                      EVENT NAME
                    </Table.TH>
                    <Table.TH className="employee-type" id="event_type">
                      EVENT TYPE
                    </Table.TH>
                    <Table.TH className="start-date" id="start_date">
                      START DATE
                    </Table.TH>
                    <Table.TH className="end-date" id="end_date">
                      END DATE
                    </Table.TH>
                    <Table.TH className="active-status" id="active_status">
                      STATUS
                    </Table.TH>
                    <Table.TH className="seal-status" id="seal_status">
                      SEAL STATUS
                    </Table.TH>
                    <Table.TH className="award-status" id="award_status">
                      AWARD STATUS
                    </Table.TH>
                    <Table.TH className="created-by" id="created_by">
                      CREATED BY
                    </Table.TH>
                    <Table.TH className="actions" id="actions_header">
                      ACTIONS
                    </Table.TH>
                  </Table.TR>
                </Table.THEAD>
                <Table.TBODY>{funcListRFQ()}</Table.TBODY>
                {resultFound()}
              </Table>
            </Section>
          </Section>
          <Section className="content-footer">
            <Section className="showing-item">
              Showing {formatNumberWithComma(showinglistRFQItem())} to{' '}
              {formatNumberWithComma(showinglistRFQItemLimit())} of{' '}
              {formatNumberWithComma(resultRFQ.total_record)} entries
            </Section>
            <Section className="paginate-wrapper">
              <Paginate
                activePage={activePage}
                itemsCountPerPage={resultRFQ.limit}
                totalItemsCount={resultRFQ.total_record}
                onChange={onChangePaginate}
              />
              <Section className="moveto-wrapper">
                <NumberFormat
                  value={this.state.searchPag}
                  label="Page"
                  isHorizontal
                  className="paginate-moveto"
                  defaultValue="1"
                  maxLength="4"
                  customInput={Input}
                  decimalSeparator={false}
                  allowNegative={false}
                  allowLeadingZeros={false}
                  onChange={onChangeNumberFormat}
                  isAllowed={isAllowedNumberFormat}
                />
                <Button
                  disabled={
                    parseInt(this.state.searchPage) <=
                    parseInt(resultRFQ.total_page)
                      ? false
                      : true
                  }
                  onClick={onClickGo}
                >
                  go
                </Button>
              </Section>
            </Section>
          </Section>
        </Section>
      )
    }
    const modalDelete = () => {
      const handlerClickCancel = e => {
        document.body.classList.remove('modal-open')
        return this.toggleModal('delete')
      }
      const handlerClickConfirm = e => {
        return this.onClickDelete(modals[0].sourcing_id)
      }
      return (
        <Modal
          id="delete_id"
          className="theme-blue"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'delete'
              })
              .map(obj => obj.isOpen)[0]
          }
          modalWidth="575px"
        >
          <Modal.Header>Delete</Modal.Header>
          <Modal.Body>
            <p className="default text-center">
              Are you sure to delete? <br />
              {modals[0].FullName}
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              id="close_modal_history_id"
              className="theme-border-gray"
              onClick={handlerClickCancel}
            >
              Cancel
            </Button>
            <Button
              id="close_modal_history_id"
              className="theme-green"
              onClick={handlerClickConfirm}
            >
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      )
    }
    const modalHistoryLog = () => {
      const funcIsOpen = () => {
        const result = modals
          .filter(modal => {
            return modal.name === 'history'
          })
          .map(obj => obj.isOpen)[0]
        return result
      }
      const isOpenModal = funcIsOpen()
      const handlerOnClickHistory = e => {
        return this.onCloseModalHistory()
      }
      return (
        <Modal
          id="history_log"
          className="history-log theme-blue"
          isOpen={isOpenModal}
        >
          <Modal.Header>History Log</Modal.Header>
          <Modal.Body>
            {this.state.loaderHistory ? (
              <Spinner />
            ) : (
              <Section className="table-header-freeze-wrapper">
                <Table className="history-log-data">
                  <Table.TBODY>
                    <Table.TR>
                      <Table.TH className="create-date">DATE</Table.TH>
                      <Table.TH className="detail">ACTIVITY</Table.TH>
                      <Table.TH className="action">ACTION BY</Table.TH>
                    </Table.TR>
                  </Table.TBODY>
                </Table>
                <Table className="history-log-data split-row-color">
                  <Table.TBODY>
                    {this.renderRfqHistories(this.state.buyerHistories)}
                  </Table.TBODY>
                </Table>
              </Section>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              id="close_modal_history_id"
              className="theme-border-gray close"
              onClick={handlerOnClickHistory}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )
    }
    return (
      <React.Fragment>
        <SourcingBuyerStyled>
          {pageTitle()}
          {renderPageContent()}
        </SourcingBuyerStyled>
        {modalDelete()}
        {modalHistoryLog()}
      </React.Fragment>
    )
  }
  render = () => this.renderSourcingList()
}

const mapStateToProps = state => {
  const { data: dataReqSeal } = state.resultStartApiReqUnseal
  const { data: dataReqSealTec } = state.resultStartApiReqUnsealTec
  const { page: page } = state.getFilterPageAllEvent
  // const { state: historyState } = state.history
  console.log(state)
  const { setSourcingEventListFilter } = state
  const {
    search,
    enterSearch,
    selectedAllStatus,
    selectedSealStatus,
    selectedAwardStatus,
    selectedAllUser,
    status,
    sealStatus,
    approvalStatus,
    allAward,
    allUser,
    eventTypeID,
    selectedAllEventType,
  } = setSourcingEventListFilter.data
  const {
    searchSourcingInput,
    enterSearchSourcingFilter,
  } = state.searchInputFilterSourcing
  const {
    searchOptionSourcingFilter2,
    selectedSourcingOptions2,
  } = state.searchSelectOptionSourcing2
  const {
    searchOptionSourcingFilter3,
    selectedSourcingOptions3,
  } = state.searchSelectOptionSourcing3
  const {
    searchOptionSourcingFilter4,
    selectedOptionsSourcing4,
  } = state.searchSelectOptionSourcing4
  const {
    searchOptionSourcingFilter5,
    selectedOptionsSourcing5,
  } = state.searchSelectOptionSourcing5
  return {
    role: state.role,
    user: state.user,
    searchSourcingInput,
    enterSearchSourcingFilter,
    searchOptionSourcingFilter2,
    selectedSourcingOptions2,
    searchOptionSourcingFilter3,
    selectedSourcingOptions3,
    searchOptionSourcingFilter4,
    selectedOptionsSourcing4,
    searchOptionSourcingFilter5,
    selectedOptionsSourcing5,
    messageReqUnseal: dataReqSeal,
    messageReqUnsealTec: dataReqSealTec,
    search,
    status,
    sealStatus,
    approvalStatus,
    allAward,
    eventTypeID,
    allUser,
    enterSearch,
    selectedAllStatus,
    selectedSealStatus,
    selectedAwardStatus,
    selectedAllEventType,
    selectedAllUser,
    page,
  }
}

export const SourcingBuyerContainer = connect(mapStateToProps)(
  SourcingBuyerContainers
)

export default SourcingBuyerContainer
